var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carte-room-service',{attrs:{"sectionId":_vm.sectionId,"pageId":_vm.pageId,"canAddFromArbo":_vm.canAddFromArbo},on:{"addToCart":_vm.addToCart}})}
var staticRenderFns = []

export { render, staticRenderFns }